var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { analyticsApi } from 'apis/analytics';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
export const useQuickViewActions = ({ location, }) => {
    const dispatch = useAppDispatch();
    const notify = useNotifications();
    const [deleteQuickView] = analyticsApi.useDeleteQuickViewMutation();
    const [updateQuickViewFavoriteState] = analyticsApi.useUpdateQuickViewFavoriteStateMutation();
    /** Handles updating a quick view. */
    const handleUpdateQuickView = (quickView) => __awaiter(void 0, void 0, void 0, function* () {
        return yield dispatch(appActions.showModal({
            modal: {
                type: 'analytics:quickView',
                arg: {
                    mode: 'update',
                    dashboardId: quickView.dashboard_id,
                    quickView,
                    location,
                },
            },
        }));
    });
    /** Handles creating a new quick view based on an existing one. */
    const handleDuplicateQuickView = (quickView) => {
        dispatch(appActions.showModal({
            modal: {
                type: 'analytics:quickView',
                arg: {
                    mode: 'duplicate',
                    dashboardId: quickView.dashboard_id,
                    quickView,
                    location,
                },
            },
        }));
    };
    /** Handles deleting a quick view. */
    const handleDeleteQuickView = (quickView) => __awaiter(void 0, void 0, void 0, function* () {
        const { isConfirmed } = yield dispatch(appActions.showModal({
            modal: {
                type: 'app:confirm',
                arg: {
                    title: `Delete "${quickView.name}"`,
                    description: 'Are you sure you want to delete this quick view?',
                    confirm: {
                        label: 'Delete',
                    },
                },
            },
        }));
        if (isConfirmed) {
            try {
                yield deleteQuickView({
                    id: quickView.id,
                    dashboardId: quickView.dashboard_id,
                });
                notify({
                    title: 'Success',
                    text: `"${quickView.name}" has been deleted.`,
                    icon: 'i-done',
                    time: 5000,
                }, NotificationType.Success);
                analytics.analyticsQuickViewDeleted({ shared: quickView.shared });
                return Promise.resolve({ isDone: true });
            }
            catch (error) {
                notify({
                    title: 'Error while deleting the quick view.',
                }, NotificationType.Error);
            }
        }
        return Promise.resolve({ isDone: false });
    });
    /** Handles updating the favorite state of a quick view. */
    const handleUpdateQuickViewFavoriteState = (quickView) => __awaiter(void 0, void 0, void 0, function* () {
        const { favorited } = quickView;
        try {
            yield updateQuickViewFavoriteState({
                quickView,
                favorited: !favorited,
            }).unwrap();
            analytics.analyticsQuickViewFavoriteToggled({ favorited: !favorited });
        }
        catch (error) {
            notify({
                title: `"${quickView.name}" could not be ${favorited ? 'unfavorited' : 'favorited'}.`,
            }, NotificationType.Error);
        }
    });
    return {
        handleUpdateQuickView,
        handleDuplicateQuickView,
        handleDeleteQuickView,
        handleUpdateQuickViewFavoriteState,
    };
};
